import { useEffect, useState } from 'react';
import { sendRequest } from '../../../../services/request';
import { useLocation } from 'react-router-dom';
import { DataGrid, GridToolbar, esES } from '@mui/x-data-grid';
import { Box, Typography, Grid, Button, TextField } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import { DataGridStyle } from '../../../../styles/DataGridSytle';

dayjs.extend(weekOfYear);

const EquipoAsignarCliente = ({ pais }) => {
    const [rows, setRows] = useState();
    const [limit, setLimit] = useState(50);
    const [page, setPage] = useState(0);
    const [rowCount, setRowCount] = useState(null);

    const URL = `${process.env.REACT_APP_API_URL}`;
    const location = useLocation();
    const equipo = location.state?.equipo;
    const promotor = location.state?.promotor;

    const cliente_donante_string =
        location.state?.campana?.division?.nombre === 'Publicidad'
            ? 'Clientes'
            : 'Donantes';

    // Condicionales
    const [loading, setLoading] = useState(true);

    // Campos selected
    const [cantidadSeleccionar, setCantidadSeleccionar] = useState('');
    const [rowsSelected, setRowsSelected] = useState([]);

    //Re-render
    const [guardado, setGuardado] = useState(false);

    useEffect(() => {
        setLoading(true);
        sendRequest(
            'get',
            `${URL}/${pais}/cliente/equipo/${equipo.id}?limit=${limit}&page=${page}&campana=${equipo.campana.id}&codigo_promotor=${promotor?.codigo}`,
        ).then((res) => {
            setLoading(false);
            setRows(res.data.items);
            setRowCount(res.data.meta.totalItems);
        });
    }, [
        URL,
        pais,
        limit,
        page,
        guardado,
        equipo.id,
        equipo.campana.id,
        promotor?.codigo,
    ]);

    const columns = [
        // {
        //     field: 'campana',
        //     headerName: 'Campaña',
        //     flex: 0.6,
        //     headerClassName: 'header',
        //     headerAlign: 'center',
        //     sortable: false,
        //     renderCell: ({ row }) => {
        //         const nombresCampana = new Set(
        //             row.tarjetones?.map(
        //                 (tarjeton) =>
        //                     `${tarjeton?.campana?.nombre} - ${dayjs(
        //                         tarjeton?.campana?.vigencia,
        //                     ).format('YYYY')}`,
        //             ),
        //         );
        //         return [...nombresCampana].toString();
        //     },
        // },
        {
            field: 'nombres',
            headerName: 'Nombres',
            flex: 0.5,
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'apellidos',
            headerName: 'Apellidos',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'tipo_documento',
            headerName: 'Tipo Doc.',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            align: 'center',
            valueGetter: ({ row }) => {
                return row.tipo_documento?.tipo;
            },
        },
        {
            field: 'numero_documento',
            headerName: 'Núm. Doc.',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'genero',
            headerName: 'Género',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            valueGetter: ({ row }) => {
                return row.genero?.genero;
            },
        },
        {
            field: 'celular',
            headerName: 'Celular',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'correo',
            headerName: 'Correo',
            flex: 1,
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'tratamiento_datos',
            headerName: 'Trat. Datos',
            headerClassName: 'header',
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            renderCell: (params) => {
                if (params.value) {
                    return <CheckIcon></CheckIcon>;
                } else {
                    return <ClearIcon></ClearIcon>;
                }
            },
        },
    ];

    const handlePaginationChange = (event, page) => {
        setPage(page);
        setLimit(event.pageSize);
    };

    const handleAsignar = async () => {
        if (rowsSelected.length > 0) {
            await sendRequest(
                'patch',
                `${URL}/${pais}/clientes-asignados/promotor`,
                {
                    clientes: rowsSelected,
                    campana: equipo.campana.id,
                    equipo: equipo.id,
                    lider: equipo.lider.id,
                    promotor: promotor.id,
                    cliente_promotor_current_week: dayjs(new Date()).week(),
                },
            );
            setGuardado(!guardado);
            setCantidadSeleccionar('');
            setRowsSelected([]);
        }
    };

    const handleRowSelectionModelChange = (newSelectionModel) => {
        setRowsSelected(newSelectionModel);
    };

    // Selecciona datos en el datagrid desde un input.
    const handleOnChangeDatosSeleccionar = async (event) => {
        const value = event.target.value;
        const numberOfRowsToSelect = parseInt(value, 10);

        if (!isNaN(numberOfRowsToSelect)) {
            setTimeout(async () => {
                const rowsToSelect = [];
                let currentPage = page;
                let remainingRows = numberOfRowsToSelect;

                while (remainingRows > 0) {
                    setLoading(true);
                    const res = await sendRequest(
                        'get',
                        `${URL}/${pais}/cliente/equipo/${equipo.id}?limit=${limit}&page=${currentPage}`,
                    );
                    setLoading(false);
                    const rowsFromPage = res.data.items.slice(0, remainingRows);
                    rowsToSelect.push(...rowsFromPage.map((row) => row.id));

                    remainingRows -= rowsFromPage.length;
                    currentPage += 1;

                    if (currentPage * limit >= rowCount) break;
                }

                setRowsSelected(rowsToSelect);
            }, 1000);
        } else {
            setRowsSelected([]);
        }
        setCantidadSeleccionar(value);
    };

    return (
        <>
            <Box sx={{ height: '100%', width: '100%' }}>
                <Grid container spacing={5} py={3} pr={3}>
                    <Grid item xs={12} md={8}>
                        <Typography
                            variant="h4"
                            color="primary"
                            sx={{
                                textAlign: 'start',
                                marginLeft: '10px',
                            }}
                        >
                            Asignar {cliente_donante_string} / {equipo?.nombre}{' '}
                            / {promotor?.nombres + ' ' + promotor?.apellidos}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleAsignar}
                        >
                            Asignar {cliente_donante_string} a Promotor
                        </Button>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}></Grid>
                    {/* Promotor predilecto con título encima */}
                    <Grid item xs={12} md={2} alignItems={'start'}>
                        <Typography variant="h6" gutterBottom color={'primary'}>
                            Convenciones
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Box
                                sx={{
                                    width: 16,
                                    height: 16,
                                    border: '1px solid',
                                    backgroundColor: '#C6E2FE',
                                }}
                            />
                            <Typography>
                                {cliente_donante_string} frecuente
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={1}></Grid>

                    {/* Campo de texto a la derecha */}
                    <Grid item xs={12} md={2}>
                        <TextField
                            type="number"
                            value={cantidadSeleccionar}
                            label="Datos a seleccionar"
                            onChange={handleOnChangeDatosSeleccionar}
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <DataGrid
                            localeText={
                                esES.components.MuiDataGrid.defaultProps
                                    .localeText
                            }
                            disableColumnSelector
                            disableDensitySelector
                            disableColumnFilter
                            disableColumnMenu
                            checkboxSelection
                            keepNonExistentRowsSelected
                            /* disableRowSelectionOnClick */
                            loading={loading}
                            initialState={{
                                pagination: {
                                    paginationModel: { pageSize: limit },
                                },
                            }}
                            rows={rows ? rows : []}
                            columns={columns}
                            slots={{
                                toolbar: GridToolbar,
                            }}
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: false,
                                    // Estos dos quitan el export
                                    printOptions: {
                                        disableToolbarButton: true,
                                    },
                                    csvOptions: { disableToolbarButton: true },
                                },
                            }}
                            paginationMode="server"
                            rowCount={rowCount ? rowCount : 0}
                            onPaginationModelChange={handlePaginationChange}
                            rowSelectionModel={rowsSelected}
                            onRowSelectionModelChange={
                                handleRowSelectionModelChange
                            }
                            getRowClassName={(params) =>
                                params.row.promotor_predilecto ===
                                promotor?.codigo
                                    ? 'promotor_predilecto'
                                    : ''
                            }
                            sx={[
                                DataGridStyle,
                                {
                                    '& .MuiDataGrid-virtualScroller': {
                                        minHeight: '20vh',
                                    },
                                    '& .promotor_predilecto': {
                                        backgroundColor: '#C6E2FE',
                                    },
                                },
                            ]}
                        />
                    </Grid>
                </Grid>

                {/* <Grid item sx={12} md={3}>
                        <Box
                            sx={{
                                width: 10,
                                height: 10,
                                border: '1px solid',
                                backgroundColor: '#C6E2FE',
                            }}
                        ></Box>
                        <Typography>Promotor predilecto</Typography>
                    </Grid>
                    <Grid item sx={12} md={9}>
                        <TextField
                            InputLabelProps={{
                                shrink: isShrunk,
                            }}
                            value={cantidadSeleccionar}
                            label="Datos a seleccionar"
                            onChange={handleOnChangeDatosSeleccionar}
                        ></TextField>
                    </Grid> */}
            </Box>
        </>
    );
};

export default EquipoAsignarCliente;
